export default [
    {
        path: '/system/scheduler/tasks',
        name: 'system-scheduler-tasks',
        component: () => import('@/views/system/Scheduler/Tasks.vue'),
    },
    {
        path: '/system/scheduler/tasks/:id',
        name: 'system-scheduler-task-card',
        component: () => import('@/views/system/Scheduler/TaskCard.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/system/translations',
        name: 'system-translations',
        component: () => import('@/views/system/Translations.vue'),
    },
    {
        path: '/system/services',
        name: 'system-services',
        component: () => import('@/views/system/Security/Services.vue'),
    },
    {
        path: '/system/services/create',
        name: 'system-services-create',
        component: () => import('@/views/system/Security/CreateUpdateService.vue'),
    },
    {
        path: '/system/services/:id/card',
        name: 'system-services-card',
        component: () => import('@/views/system/Security/CreateUpdateService.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/system/security/operations',
        name: 'system-security-operations',
        component: () => import('@/views/system/Security/Operations.vue'),
    },
    {
        path: '/system/security/user-interface',
        name: 'system-security-user-interface',
        component: () => import('@/views/system/Security/UserInterface.vue'),
    },
    {
        path: '/system/security/user-interface/create',
        name: 'system-security-user-interface-create',
        component: () => import('@/views/system/Security/CreateUpdateUserInterface'),
    },
    {
        path: '/system/security/user-interface/:id/card',
        name: 'system-security-user-interface-card',
        component: () => import('@/views/system/Security/CreateUpdateUserInterface'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/system/security/user-roles',
        name: 'system-security-user-roles',
        component: () => import('@/views/system/Security/UserRoles.vue'),
    },
    {
        path: '/system/security/user-roles/create',
        name: 'system-security-user-role-create',
        component: () => import('@/views/system/Security/CreateUpdateUserRole.vue'),
    },
    {
        path: '/system/security/user-roles/:id/card',
        name: 'system-security-user-role-card',
        component: () => import('@/views/system/Security/CreateUpdateUserRole.vue'),
        props: route => route.params,
    },
]
